import React from 'react';
import { FaTwitter, FaInstagram, FaTiktok } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();

    const handleScroll = (path) => {
        if (location.pathname === path) {
            window.scrollTo(0, 0);
        }
    };

    return (
        <motion.footer
            className="footer"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
        >
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <h3>Soruly</h3>
                        <p>Sınav sürecindeki dijital rehberiniz.</p>
                    </div>

                    <div className="footer-links">
                        <h4>Hızlı Erişim</h4>
                        <ul>
                            <li><Link to="/" onClick={() => handleScroll('/')}>Ana Sayfa</Link></li>
                            <li><Link to="/features" onClick={() => handleScroll('/features')}>Özellikler</Link></li>
                            <li><Link to="/screenshots" onClick={() => handleScroll('/screenshots')}>Görüntüler</Link></li>
                            <li><Link to="/developer" onClick={() => handleScroll('/developer')}>Geliştirici</Link></li>
                            <li><a href="/#download">İndir</a></li>
                        </ul>
                    </div>

                    <div className="footer-links">
                        <h4>Yasal</h4>
                        <ul>
                            <li><Link to="/legal" onClick={() => handleScroll('/legal')}>Gizlilik Politikası</Link></li>
                            <li><Link to="/legal" onClick={() => handleScroll('/legal')}>Kullanım Koşulları</Link></li>
                            <li><Link to="/developer" onClick={() => handleScroll('/developer')}>İletişim</Link></li>
                        </ul>
                    </div>

                    <div className="footer-social">
                        <h4>Takip Edin</h4>
                        <div className="social-icons">

                            <a
                                href="https://twitter.com/sorulyhatatakip"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Twitter"
                            >
                                <FaTwitter />
                            </a>

                            <a
                                href="https://instagram.com/soruly.hatadefteri"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <FaInstagram />
                            </a>

                            <a
                                href="https://tiktok.com/@soruly.hatadefteri"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Tiktok"
                            >
                                <FaTiktok />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Soruly. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;
